const isSuportLocalStorage = !!window.localStorage

export default {
  get: (key) => {
    if (!isSuportLocalStorage) return
    return window.localStorage.getItem(key)
  },

  set: (key, val) => {
    if (!isSuportLocalStorage) return
    try {
      if (typeof val !== 'string') {
        val = JSON.stringify(val)
      }
      window.localStorage.setItem(key, val)
    } catch (e) {
      console.error(e)
    }
  },
}
